import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import DhlDeReturnsCredentialsStore from '../../../../stores/credentials/shipping/dhl-de-returns-credentials-store';

interface IProps {
    credentialsStore: DhlDeReturnsCredentialsStore,
    vGroup: IValidationGroup,
}

const DhlDeReturnsCredentials: React.FC<IProps> = observer(({
                                                       credentialsStore,
                                                       vGroup,
                                                   }) => {
    return (
        <>
            <FormFieldLine
                required
                label='DHL DE Returns username'
                key='username'
                note='Your DHL DE Returns username'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DHL DE Returns password'
                key='password'
                note='Your DHL DE Returns password'
            >
                <Input
                    value={credentialsStore.password}
                    onChange={credentialsStore.setPassword}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default DhlDeReturnsCredentials;
